<div @transformPopover class="vex-popover">
  @switch (renderMethod) {
    @case ('text') {
      <div [innerHTML]="textContent"></div>
    }
    @case ('template') {
      <ng-container
      *ngTemplateOutlet="templateContent; context: context"></ng-container>
    }
    @case ('component') {
      <ng-container *ngComponentOutlet="componentContent"></ng-container>
    }
  }
</div>
